import i18n from "@/i18n";

let lastRawTitle: string | null = null;
let lastTitleKey: string | null = null;
let listenerRegistered = false;

function slugifyTitle(raw: string) {
  return raw
    .trim()
    .toLowerCase()
    .replace(/['’]/g, "")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .replace(/_+/g, "_");
}

export function titleKeyFromRaw(rawTitle: string) {
  return slugifyTitle(rawTitle);
}

/**
 * Set the document title using a stable i18n key.
 * The key is derived from the raw title and stored under `titles.*`.
 */
export function setDocumentTitle(rawTitle: string, keyOverride?: string) {
  const key = keyOverride ?? titleKeyFromRaw(rawTitle);
  lastRawTitle = rawTitle;
  lastTitleKey = key;
  if (!listenerRegistered) {
    i18n.on("languageChanged", () => {
      if (!lastRawTitle || !lastTitleKey) return;
      document.title = i18n.t(lastTitleKey, {
        ns: "titles",
        defaultValue: lastRawTitle,
      });
    });
    listenerRegistered = true;
  }
  document.title = i18n.t(key, { ns: "titles", defaultValue: rawTitle });
  return `titles:${key}`;
}
